import React from 'react';
import AudienceLanding from './AudienceLanding';

export default function CentreLanding() { return <AudienceLanding kind="centre" />; }
